<template>
  <span class="remark-cell" @click="handleClick">
    {{ truncatedText }}
  </span>
</template>

<script setup>
import { computed, h } from "vue";
import { ElMessageBox } from "element-plus";

const props = defineProps({
  scope: {
    type: Object,
    default: () => ({}),
  },
});

const text = computed(() => props.scope?.row?.postDuty || "");

const truncatedText = computed(() => {
  if (!text.value) return "";
  // return text.value.length > 10 ? text.value.slice(0, 10) + "..." : text.value;
  return "点击查看";
});

const handleClick = (e) => {
  e.stopImmediatePropagation();
  ElMessageBox.alert(
    h(
      "div",
      {
        style: {
          maxHeight: "300px",
          minHeight: "300px",
          overflowY: "auto",
          whiteSpace: "pre-wrap",
          wordBreak: "break-all",
        },
      },
      text.value || "暂无内容"
    ),
    "岗位职责",
    {
      confirmButtonText: "关闭",
    }
  );
};
</script>

<style scoped>
.remark-cell {
  color: #409eff;
  cursor: pointer;
  text-decoration: none;
}
.remark-cell:hover {
  text-decoration: underline;
}
</style>
